import { EllipsisDivStyle, TagStyle } from './RecapInputStyles'

const RecapInputTagUsersList = ({
  value,
  color,
}: {
  value: File | string
  color: string
}) => {
  return (
    <div className="flex flex-row items-center gap-2">
      <TagStyle
        color={color}
        className="flex flex-row items-center justify-start py-1 px-2 rounded gap-2"
      >
        <EllipsisDivStyle className="flex flex-auto">
          <span>{value instanceof File ? value.name : value}</span>
        </EllipsisDivStyle>
      </TagStyle>
    </div>
  )
}

export default RecapInputTagUsersList
